/* eslint-disable */
/*

MINIATUR WUNDERLAND HAMBURG

Funktionen für Google Analytics E-Commerce-Tracking in Ticketbuchung-App

Version: 1.3
Datum: 30.10.19
Autor: Thomas Cerny




 - - - -    README      - - - - -



- - WARENKORB / PRODUKT-DATEN - - -


Wenn Artikel (also Tickets, Voucher etc.) in den Warenkorb gelegt oder aus diesem entfernt werden,
oder sonstige Aktionen mit Artikeln stattfinden, sind alle Artikel in einem Array nach folgendem Muster
zu übergeben.
WICHTIG: Immer die deutschen Bezeichnungen für alles aus der Ticket-API verwenden,
also Namen von Veranstaltungen, Ticketvarianten (wie "Erwachsener" etc.):

   [
      {
         'name':        string,
         'variant':     string,
         'category':    string,
         'id':          string,
         'price':       int,
         'taxRate':     int,
         'quantity':    int, // optional
         'list':        string, // optinal
         'position':    int, // optional
         'date':        string, // optional
         'gap':         int // optional
      },
      {
         ... wie oben, falls mehrere Artikel oder verschiedene Varianten eines Artikels
      }
   ]

   WERTE:

   name (String)
      "Ticket" für Tickets,
      "Gift Certificate" für Ticketgutscheine,
      "Ticket Große Pötte & Kleine Züge",
      "Ticket Kulinarische Weltreise",
      "Ticket Nachts im Wunderland",
      "Ticket Rollstuhlabend",
      ...
      "Voucher Hafenrundfahrt",
      "Voucher Stadtrundfahrt",
      "Voucher Hamburg Dungeon",

   variant (String):
      Bei Ticketreservierung: "Reservierung"
      Sonst: ausgeschriebener Name der Ticket- oder Voucherart wie von Ticket-API geliefert ("Erwachsener", "Senioren (ab 65 Jahre)", "Familienkarte"...)

   category (String):
      - bei E-Tickets:
         Tickets/Regular
      - bei Veranstaltungstickets:
         Tickets/Events/Regular
      - bei Ticketreservierung:
         Tickets/Regular/Reservation
      - bei Vouchern:
         Tickets/Vouchers
      - bei Ticketgutscheinen:
         Tickets/Regular/Gift Certificates
      -bei Veranstaltungsgutscheinen:
         Tickets/Events/Gift Certificates

   id (String):
      - bei Ticketreservierung:
         wt.r
      - bei E-Tickets:
         wt.n, wobei n die von der Ticket-API gelieferte ID der Ticketvariante ist (zB 1 für Erwachsender, 2 für Kind bis 15 Jahre, ...)
      - bei Ticketgutscheinen:
         wg.n, wobei n die von der Ticket-API gelieferte ID der Ticketvariante ist (zB 1 für Erwachsender, 2 für Kind bis 15 Jahre, ...)
      - bei Tickets für Veranstaltungen:
         wt.e-n, wobei n die von der Ticket-API gelieferte ID der Ticketvariante ist (zB 67 und 72 für Erwachsener, ...)
      - bei Ticketgutscheinen für Veranstaltungen:
         wg.e-n, wobei n die von der Ticket-API gelieferte ID der Ticketvariante ist (zB 67 und 72 für Erwachsener, ...)
      - bei Voucher Hafenrundfahrt:
         wv.hr-n, wobei n die von der Ticket-API gelieferte ID der Ticketvariante ist (zB. 1 für Erwachsener, ...)
      - bei Voucher Stadtrundfahrt:
         wv.sr-n, wobei n die von der Ticket-API gelieferte ID der Ticketvariante ist (zB. 3 für Erwachsener, ...)
      - bei Voucher Hamburg Dungeon:
         wv.du-n, wobei n die von der Ticket-API gelieferte ID der Ticketvariante ist (zB. 5 für Erwachsener, ...)

   price (Int):
      - Bruttopreis des Artikels in EUR multipliziert mit 100 (aber nicht mit Anzahl multipliziert!)
         bei Reservierung: 1100, ansonsten der Betrag der von der Ticket-API geliefert wird

   taxRate (Int):
      - Steuersatz des Artikels multipliziert mit 100

   quantity (Int):
      - Zum Warenkorb hinzuzufügende oder entfernende Anzahl des jeweiligen Artikels. Bei Produktimpressionen (zB Upselling-Liste muss keine Anzahl übergeben werden)

   list (String):
      - Wenn Artikel in Produktliste angezeigt wurde, diese hier mitübergeben
         - Ticketapp Event-Teaser: bei Event-Teaser
         - Ticketapp Upsell Options: bei Vouchern etc.
         - Website [ Eventname ] Date List: wenn zB die Buchung einer Sonerveranstaltung mit übergebenem Datum aufgerufen wurde,
            wobei Eventname der deutsche Name der jeweiligen Veranstaltung ist

   position (Int, optional):
      - Position des Produkts in einer Produktliste, beginnend bei 1
         - bei Vouchern die Reihenfolge, in der diese angezeigt werden
         - bei Event-Teasern:
            1: Links (über/unter linker Gapliste - Tag vor dem gewählten Datum)
            2: Mitte (über/unter aktiver Gapliste - ausgewählter Tag)
            3: rechts (über/unter rechter Gapliste - nächster Tag)

   date (String, optional):
      - Bei Tickets, Reservierungen und Führungen das Besuchsdatum in der Form YYYY-MM-DD

   gap (Int, optional):
      - Bei Tickets, Reservierungen und Führungen das gewählte Gap

*/

window.dataLayer = window.dataLayer || [];

export default function mwTicketBookingEcommerceTracking() {

  this.init = function(section, product) {
    /* Aufzurufen bei Start einer Sitzung in der Ticketbuchung oder wenn Bereich gewechselt wird,
    zB von E-Ticket-Buchung zu Reservierung, leert automatisch einen evtl. vorhandenen Warenkorb


    PARAMETER

       section: String
          Werte:
             eticket: E-Ticketbuchung
             reservation: Ticketreservierung
             events: Sonderveranstaltung
             giftCertificates: Gutscheine


       product: array
          Struktur wie im README unter Warenkorb beschrieben mit 1 Artikel.
          - bei E-Ticket-Buchung: 1 Ticket für Erwachsene
          - bei Ticketreservierung: 1 Reservierung
          - bei Veranstaltungen: 1 Ticket für Erwachsene für die jeweilige Veranstaltung
          - bei regulären Ticket-Gutscheinen: 1 Gutschein für Erwachsene
          - bei Veranstaltungs-Ticket-Gutscheinen: 1 Gutschein für Erwachsene für die VA
          - bei Papiertickets: leeres Array


    RÜCKGABEWERT: keiner

    */


    if (product.length === 1) {
      this.productDetailView(product[0]);
    }
    this.appSection = section;

    this.sendGaEvent(this.location, this.appSection, "Start");
    this.sendGa2Event("ticket_app", {section: this.appSection, progress: "start"});

  };


  this.bookingSectionClick = function(section, product) {
    /* Aufzurufen, wenn ein anderer Reiter der Ticketbuchung ("E-Ticket kaufen", "Tickets reservieren",
    "Papiertickets & Gutscheine") angeklickt wurde

    PARAMETER

       section: String
          Werte:
             eticket: E-Ticketbuchung
             reservation: Ticketreservierung
        events: Sonderveranstaltung
             giftCertificates: Gutscheine

    product: array
          Struktur wie im README unter Warenkorb beschrieben mit 1 Artikel.
          - bei E-Ticket-Buchung: 1 Ticket für Erwachsene
          - bei Ticketreservierung: 1 Reservierung
          - bei Veranstaltungen: 1 Ticket für Erwachsene für die jeweilige Veranstaltung
          - bei regulären Ticket-Gutscheinen: 1 Gutschein für Erwachsene
          - bei Veranstaltungs-Ticket-Gutscheinen: 1 Gutschein für Erwachsene für die VA
          - bei Papiertickets: leeres Array

    RÜCKGABEWERT: keiner
    */

    this.sendGaEvent("Click", this.location + '_' + this.appSection, "Top Nav " + section);
    this.sendGa2Event("ticket_app", {section: this.appSection, action: "changeSection", newSection: section});

    this.init(section, product);
  };


  this.updateCart = function(cart) {
    /* Aufzurufen, wenn sich am Warenkorb etwas geändert hat (Artikel hinzugefügt,
    entfernt, Anzahl geändert, Wechsel von Reservierung zu E-Ticket etc.).
    Wenn zusammen mit einer der checkout-Schritt-Methoden unten aufgerufen, immer
    zuerst .updateCart() aufrufen und dann die Methode für den jeweiligen
    Checkout-Schritt (zB persönliche Daten)

       PARAMETER
          cart: array
                aktueller Warenkorb wie im README unter Warenkorb beschrieben
                WICHTIG: bei Tickets etc. auch das gewählte Datum als date mit übergeben

       RÜCKGABEWERT: keiner
       */

    this.updateInternalCart(cart);
  };


  this.gapListView = function() {
    // Klick auf "Verfügbarkeit prüfen", Gapliste wird angezeigt

    this.sendGaEvent(this.location, this.appSection, "Gap List");
    this.sendGaEvent("View", this.location, "Gap List");
    this.sendGa2Event("ticket_app", {section: this.appSection, progress: "gap_list"});
  };


  this.eventTeaserImpression = function(teaser, products) {
    /* Impression einer Anzeige im Event-Teaser

    Bei anfänglicher Anzeige der Gapliste für den Event-Teaser oben aufzurufen (nach Klick
    auf "Verfügbarkeit prüfen". Wenn bis zum unteren Teaser gescrollt wurde, auch für diesen aufrufen.

    Wenn Datum gewechselt wird, für geänderten oberen Eventteaser auch wieder aufrufen. Das gleiche gilt
    den Teaser unten, aber nur, wenn er dann (oder durch Scrollen) in den sichtbaren Viewport kommt.


    PARAMETER

       teaser: String: welcher Event-Teaser
          Werte:
             gaplist_top: Event-Teaser oben
             gaplist_bottom: Event-Teaser unten

       products: array
          wie im README unter Warenkorb beschrieben, immer jeweils die Variante, Artikel-ID und
          Einzelnettopreis für Erwachsene.
          WICHTIG: 'position' (Reihenfolge der Anzeige im Event-Teaser) auch mit übergeben!


    RÜCKGABEWERT: keiner

    */

    this.promoView(products.map(product => ({
        'name': this.location + ' Event-Teaser',
        'creative': product.name,
        'position': 'ticketapp-eventteaser-' + teaser + '-' + product.position
      })));
  };


  this.eventTeaserClick = function(teaser, products) {
    /* Klick auf eine Anzeige im Event-Teaser

    Bei Klick auf ein Element in den Event-Teasern über/unter Gapliste aufzurufen. Parameter identisch wie
    bei .eventImpression()



    PARAMETER

       products: array
          mit dem angeklickten Produkt. Wie im README unter Warenkorb beschrieben, die Variante,
          Artikel-ID und Einzelnettopreis für Erwachsene. WICHTIG: 'position' (Reihenfolge der Anzeige im
          Event-Teaser) auch mit übergeben!

       teaser: String: welcher Event-Teaser
          Werte:
             gaplist_top: Event-Teaser oben
             gaplist_bottom: Event-Teaser unten

       position: Int: an welcher Stelle im jeweiligen Event-Teaser angezeigt worden, als er angeklickt wurde
          Werte:
             1: links (über/unter linker Gapliste - Tag vor dem gewählten Datum)
             2: Mitte (über/unter aktiver Gapliste - ausgewählter Tag)
             3: rechts (über/unter rechter Gapliste - nächster Tag)

    RÜCKGABEWERT: keiner

    */

    this.promoClick({
      'name': this.location + ' Event-Teaser',
      'creative': products[0].name,
      'position': 'ticketapp-eventteaser-' + teaser + '-' + products[0].position
    });
    this.sendGaEvent("Click", this.location, "Event-Teaser");
    this.sendGa2Event("ticket_app", {section: this.appSection, action: "eventTeaser_click"});
  };


  this.eventProductView = function(product) {
    /* Buchung für Abendveranstaltung aufgerufen (das Popup, - URL .../buchung/sonderveranstaltung/...)


    PARAMETER
       product: array
          wie im README unter Warenkorb beschrieben, immer jeweils die Variante, Artikel-ID und
          Einzelnettopreis für Erwachsene
          Wenn über eine Produktliste aufgerufen, dann bitte list damit ausfüllen (bei
          Event-Teaser: Ticketapp Event-Teaser) und Position darin übergeben
          (bei Event-Teaser Position von links gezählt)

    RÜCKGABEWERT: keiner

    */
    this.sendGaEvent("View", this.location, "Event " + product[0].name);
    this.productDetailView(product[0]);
  };


  this.gapSelected = function() {
    /* Aufzurufen, wenn Gap gewählt wurde. Da sich hierdurch der Warenkorb stets ändert, immer auch
    .updateCart() aufrufen

    PARAMETER
       keine

    RÜCKGABEWERT: keiner
    */

    this.sendGaEvent("Click", this.location, "Gap");
    this.sendGaEvent(this.location, this.appSection, "Gap selected");
    this.sendGa2Event("ticket_app", {section: this.appSection, progress: "gap_selected"});
  };


  this.checkoutOverview = function() {
    /* Aufzurufen wenn Checkout-Prozess gestartet wurde (Schritt 2 - Übersicht der Ticket-App aufgerufen)
    Sicherheitshalber VOR diesem Aufruf stets noch einmal .updateCart() aufrufen

    RÜCKGABEWERT: keiner
    */
    this.sendGaEvent("View", this.location, "Booking Overview");
    this.sendGaEvent(this.location, this.appSection, "Booking Overview");
    this.sendGa2Event("ticket_app", {section: this.appSection, progress: "booking_overview"});
    this.sendGa2Event("begin_checkout", {currency: this.ecData.currency});
    this.checkoutStep(1);
  };


  this.checkoutUpsellView = function(products) {
    /* Aufzurufen wenn Upselling-Optionen wie Voucher angezeigt werden (während Schritt 2 der Ticket-App Scrolling
    nach unten oder Klick auf "weiter zu unseren Empfehlungen"). Werden Voucher in den Warenkorb gelegt, .addToCart()
    mit entsprechendem Voucher in gewählten Varianten und jeweils gewählten Anzahlen ausführen.

    PARAMETER
       products: array der dargestellten Vouchers etc. wie im README unter Warenkorb beschrieben, immer jeweils die
       Variante, Artikel-ID und Einzelnettopreis für Erwachsene
       als

    RÜCKGABEWERT: keiner
    */

    this.sendGaEvent("View", this.location, "Upsell Options");
    this.sendGaEvent(this.location, this.appSection, "Booking Overview Cross-Selling");
    this.sendGa2Event("ticket_app", {section: this.appSection, progress: "booking_overview_cross-selling"});
    this.productImpression(products, this.location + " Upsell Options");
    this.promoView(products.map(product => ({
        'name': this.location + ' Upsell Options',
        'creative': product.name,
        'position': 'ticketapp-upsell-options-' + product.position
      })));
  };


  this.checkoutUpsellViewDetail = function(product) {
    /* Aufzurufen wenn bei einer der Upselling-Optionen wie Voucher der Button "Mehr Informationen" geklickt wird
    (während Schritt 2 der Ticket-App). Werden Voucher in den Warenkorb gelegt, .checkoutUpsell_addToCart() mit
    entsprechendem Voucher in gewählten Varianten und jeweils gewählten Anzahlen ausführen.

    PARAMETER
       product: array des geklickten Vouchers etc. wie im README unter Warenkorb beschrieben, immer jeweils die
       Variante, Artikel-ID und Einzelnettopreis für Erwachsene

    RÜCKGABEWERT: keiner
    */

    this.productDetailView(product[0], this.location + " Upsell Options");
    this.promoClick({
      'name': this.location + ' Upsell Options',
      'creative': product[0].name,
      'position': 'ticketapp-upsell-options-' + product[0].position
    });
  };


  this.checkoutUpsell_addToCart = function(product) {
    /* Aufzurufen wenn von einer der der Upselling-Optionen wie Voucher Artikel dem Warenkorb hinzugefügt werden.
    (während Schritt 2 der Ticket-App).

    Da sich hierbei stets der Warenkorb ändert, NACH diesem Aufruf auch immer auch mit updateCart() den
    geänderten Warenkorb übergeben.

    PARAMETER
       product: array
          Hinzugefügter Voucher etc. wie im README unter Warenkorb beschrieben, immer Variante Erwachsener und
          Anzahl 1;

    RÜCKGABEWERT: keiner
    */

    this.sendGaEvent(this.location, this.appSection, "Booking Overview Cross-Selling AddToCart");

    this.productClick(product[0], this.location + " Upsell Options");

    this.promoClick({
      'name': this.location + ' Upsell Options',
      'creative': 'ticket-upselling-' + product[0].name,
      'position': 'ticketapp-upsell-options-' + product[0].position
    });
  };


  this.checkoutPersonalData = function() {
    /* Aufzurufen, wenn Schritt 3 der Ticket-App (Persönliche Daten) aufgerufen wurde.

    RÜCKGABEWERT: keiner
    */

    this.sendGaEvent(this.location, this.appSection, "Personal Data");
    this.sendGa2Event("ticket_app", {section: this.appSection, progress: "personal-data"});
    this.checkoutStep(2);
  };


  this.checkoutPersonalData_Returning = function(returning) {
    /* Aufzurufen, wenn eine der Optionen bei "Hat bereits das Wunderland besucht" angeklickt wird.
    Bei mehreren Personen Aufruf bei jeder Person

    PARAMETER
       returning: string
          Werte:
             1: hat schon einmal das Wunderland besucht
             0: nein
             -1: keine Angabe


    RÜCKGABEWERT: keiner
    */
    var gaVal = {
      "1": ["Returning Visitor", false],
      "0": ["New Customer", true],
      "-1": ["No Returning Info given"]
    };

    this.sendGaEvent("Property", "Customer", gaVal[returning][0]);

    if (returning != "-1") {
      this.dlPush({
        'event': 'userInfo',
        'userInfo_name': 'ticketbooking_user_newCustomer',
        'userInfo_value': gaVal[returning][1]
      });
    }
  };


  this.checkoutPersonalData_Newsletter = function(optin) {
    /* Aufzurufen, wenn Formular mit persönlichen Daten gesendet wird

    PARAMETER
       optin: bool
          Werte:
             true: Newsletter abonniert
             false: nicht abonniert


    RÜCKGABEWERT: keiner
    */

    this.sendGaEvent("Conversion", "Newsletter Subscription", optin);
    this.dlPush({
      event: 'userInfo',
      userInfo_name: 'newsletter_subscription',
      userUnfo_value: true
    });
  };


  this.checkoutPayment = function(paymentMethod) {
    /* Aufzurufen, wenn Schritt 4 der Ticket-App (Beahlung) abgeschlosen wurde (vor ggf.
  Weiterleitung zu Zahlungsanbieter, Überspringen bei Ticketreservierung

    PARAMETER
       paymentMethod: string
          Werte:
             wie von uns geliefert: x_X

    RÜCKGABEWERT: keiner
    */

    this.checkoutStep(3, paymentMethod);
    this.sendGaEvent(this.location, this.appSection, "Payment: " + paymentMethod);
    this.sendGaEvent("Ecommerce", "Payment Method", paymentMethod);
    this.sendGa2Event("ticket_app", {section: this.appSection, progress: "payment", payment_method: paymentMethod});

  };


  this.checkoutConfirmation = function(paymentSuccessful, bookingId) {
    /* Aufzurufen, wenn Schritt 5 der Ticket-App (bestätigung) aufgerufen wurde. Vorher noch einmal updateCart() aufrufen,
   falls durch den Seitenwechsel zum externen Zahlungsanbieter die Tracking Cart-Daten verloren gegangen sind.

     PARAMETER
        paymentSuccessful: bool
           Werte: true oder false
        bookingId: String, optional (nur bei erfolgreicher Zahlung notwendig)
           Wert: Wunderland-Buchungsnummer

     RÜCKGABEWERT: keiner
     */


    if (!paymentSuccessful) {
      this.sendGaEvent("Ecommerce", "Checkout Abort", "Payment failed");
      this.sendGaEvent(this.location, this.appSection, "Payment failed");
    } else {
      this.ecData.transactionId = bookingId;
      this.checkoutStep(4);
      this.sendGaEvent(this.location, this.appSection, "Confirmation");
      this.sendGa2Event("ticket_app", {section: this.appSection, progress: "confirmation"});
      this.purchase();
    }
  };


  this.ticketCancelled = function(bookingId) {
    /* Aufzurufen, wenn eine Ticketbestellung storniert wird

    PARAMETER
       bookingId: String
          Wert: Wunderland-Buchungsnummer

    RÜCKGABEWERT: keine
    */

    this.refundPurchase(bookingId);
  };


  // - - - - - - -   AB HIER NUR NOCH PRIVATE METHODEN UND EIGENSCHAFTEN DER KLASSE,
  // - - - - - - - - -  BITTE NICHT VON AUSSERHALB AUFRUFEN ODER SETZEN!!   - - - - - - -


  this.cart = [];

  this.ecData = {
    'transactionId': '',
    'affiliation': 'Miniatur Wunderland Ticketbuchung',
    'brand': 'Miniatur Wunderland',
    'currency': 'EUR',
    'coupon': '',
    'couponUsed': false,
    'eticketServiceCharge': 0.5
  };

  this.evtPrefix = "ticketapp_";
  this.location = "TicketApp";
  this.appSection = "eticket";

  this.sendGaEvent = function(category, action, label) {
    this.dlPush({
      event: 'gaEvent',
      gaEventCategory: category,
      gaEventAction: action,
      gaEventLabel: label
    });
  };


  this.sendGa2Event = function(eventName, parameters = {}) {
    var parameterCount = 0;
    var psh = {
      customEvent_name: eventName
    };
    for (var el in parameters) {
      if (parameters.hasOwnProperty(el)) {
        parameterCount++;
        psh['customEvent_parameter' + parameterCount + '_name'] = el;
        psh['customEvent_parameter' + parameterCount + '_value'] = parameters[el];
      }
    }
    psh.event = 'ga2CustomEvent_' + parameterCount + 'params';
    this.dlPush(psh);
  };


  this.promoView = function(promotions) {
    // Interne Werbung angesehen, zB Event-Teaser, Voucher

    this.dlPush({
      'event': this.evtPrefix + 'promoView',
      'ecommerce': {
        'promoView': {
          'promotions': promotions
        }
      }
    });

    for (var i = 0; i < promotions.length; i++) {
      this.sendGa2Event('promotion_view', {
        promotion_product: promotions[i].creative,
        promotion_location: promotions[i].position,
      });
    }
  };

  this.promoClick = function(promo) {
    // Interne Werbung angeklickt, zB Event-Teaser, Voucher

    var clickPromo = Array.isArray(promo) && promo.length > 1 ? promo[0] : promo;

    this.dlPush({
      'event': this.evtPrefix + 'promoClick',
      'ecommerce': {
        'promoClick': {
          'promotions': [clickPromo]
        }
      }
    });

    this.sendGa2Event('promotion_click', {
      'promotion_product': clickPromo.creative,
      'promotion_location': clickPromo.location,
    });
  };


  this.productImpression = function(items, list) {
    var ecItems = items.map(item => {
        if (typeof list !== "undefined" && list !== "")
          item.list = list;
        return this.getEcItem(item);
    });

    this.dlPush({
      'event': this.evtPrefix + 'productImpression',
      'ecommerce': {
        'currencyCode': this.ecData.currency,
        'impressions': ecItems.map(item => this.getGaEcommItem(item))
      }
    });

    this.sendGa2Event("view_item_list", {items: ecItems.map(item => this.getGa2EcommItem(item))});
  };

  this.productClick = function(product, list) {

    var req = {
      'event': this.evtPrefix + 'productClick',
      'ecommerce': {
        'currencyCode': this.ecData.currency,
        'click': {
          'products': [this.getGaEcommItem(this.getEcItem(product))]
        }
      }
    };

    if (typeof list != "undefined") {
      req.ecommerce.click.actionField = {'list': list};
    }

    this.dlPush(req);
  };

  this.productDetailView = function(product, list = "") {

    var productList = list;

    if (productList == "" && typeof product.list != "undefined") {
      productList = product.list;
    }

    var req = {
      'event': this.evtPrefix + 'productDetailView',
      'ecommerce': {
        'currencyCode': this.ecData.currency,
        'detail': {
          'products': []
        }
      }
    };

    var ecItem = this.getEcItem(product);

    if (productList != "") {
      ecItem.list = productList;
      req.ecommerce.detail.actionField = {'list': productList};
    }
    req.ecommerce.detail.products.push(this.getGaEcommItem(ecItem));

    this.dlPush(req);
    this.sendGa2Event("view_item", {items: [this.getGa2EcommItem(ecItem)]});
  };


  this.checkoutStep = function(step, option) {

    var value = 0;
    for (var item of this.cart) {
      if (item.hasOwnProperty("price")) {
        var qty = item.hasOwnProperty("quantity") ? item.quantity : 1;
        value += item.price * qty;
      }
    }

    var req = {
      'event': this.evtPrefix + 'checkoutStep',
      'ecommerce': {
        'checkout': {
          'actionField': {
            'step': step
          },
          'products': this.cart.map(item => this.getGaEcommItem(item))
        }
      },
      'currency': this.ecData.currency
    };

    var ga2EvtParams = {
      'checkout_step': step,
      'value': value / 100,
      'currency': this.ecData.currency,
      'items': this.cart.map(item => this.getGa2EcommItem(item))
    };

    if (typeof option !== "undefined") {
      req.ecommerce.checkout.actionField.option = option;
      ga2EvtParams.checkout_option = option;
    }

    this.dlPush(req);
    this.sendGa2Event("checkout_progress", ga2EvtParams);
  };


  this.purchase = function() {

    function getTax(netPrice, taxRate) {
      if (Number.isNaN(netPrice) || Number.isNaN(taxRate)) {
        return 0;
      }
      return netPrice * taxRate / 10000;
    }

    var totalI = 0, taxI = 0;
    var total = 0.0, tax = 0.0, shipping = 0.0;

    for (var i = 0; i < this.cart.length; i++) {
      var qty = typeof this.cart[i].quantity != "undefined" ? this.cart[i].quantity : 1;
      if (this.cart[i].hasOwnProperty("price")) {
        totalI += qty * this.cart[i].price;
        taxI += getTax(qty * this.cart[i].price, this.cart[i].taxRate);
      }
      if (this.cart[i].id.substr(0, 2) == "wt" && this.cart[i].id != "wt.r") {
        shipping += qty * this.ecData.eticketServiceCharge;
      }
    }

    total = totalI / 100;
    tax = taxI / 100;

    this.dlPush({
      'event': this.evtPrefix + "purchase",
      'transactionId': this.ecData.transactionId,
      'transactionAffiliation': this.ecData.affiliation,
      'transactionTotal': total,
      'transactionTax': tax,
      'transactionShipping': shipping,
      'transactionProducts': this.cart.map(item => this.getGaTransactionItem(item)),
      'ecommerce': {
        'currencyCode': this.ecData.currency,
        'purchase': {
          'actionField': {
            'id': this.ecData.transactionId,
            'affiliation': this.ecData.affiliation,
            'revenue': total + tax + shipping,
            'tax': tax,
            'shipping': shipping
          },
          'products': this.cart.map(item => this.getGaEcommItem(item))
        }
      }
    });

    this.sendGa2Event("purchase", {
      'value': total,
      'currency': this.ecData.currency,
      'transaction_id': this.ecData.transactionId,
      'shipping': shipping,
      'tax': tax,
      'affiliation': this.ecData.affiliation,
      'items': this.cart.map(item => this.getGa2EcommItem(item))
    });
  };


  this.refundPurchase = function(transactionId) {
    this.dlPush({
      'event': this.evtPrefix + "refund",
      'ecommerce': {
        'refund': {
          'actionField': {'id': transactionId}
        }
      },
      'currency': this.ecData.currency
    });

    this.sendGa2Event("purchase_refund", {
      'transaction_id': transactionId
    });
  };


  this.updateInternalCart = function(newCart) {
    let currentItems = newCart.map(el => this.getEcItem(el));

    var i = 0, j = 0;
    var found = false;
    var addItems = [], removeItems = [], value = 0.0, qty = 0;
    var tmpItem = {};

    if (this.cart.length == 0) {
      addItems = currentItems;

    } else if (newCart.length == 0) {
      removeItems = this.cart;

    } else {
      // Items in new BASKET
      for (i = 0; i < currentItems.length; i++) {
        found = false;

        for (j = 0; j < this.cart.length; j++) {
          if (currentItems[i].id == this.cart[j].id) {
            if (currentItems[i].quantity > this.cart[j].quantity) {
              tmpItem = this.clone(currentItems[i]);
              tmpItem.quantity = currentItems[i].quantity - this.cart[j].quantity;
              addItems.push(tmpItem);
            } else if (currentItems[i].quantity < this.cart[j].quantity) {
              tmpItem = this.clone(currentItems[i]);
              tmpItem.quantity = this.cart[j].quantity - currentItems[i].quantity;
              removeItems.push(tmpItem);
            }
            found = true;
            break;
          }
        }

        if (!found) {
          addItems.push(currentItems[i]);
        }
      }

      // Remove items by checking everything in old basket
      for (i = 0; i < this.cart.length; i++) {
        let cartItem = this.clone(this.cart[i]);
        let found = false;

        for (j = 0; j < currentItems.length; j++) {
          let currentItem = currentItems[j];

          if (cartItem.id == currentItem.id) {
            found = true;

            if (cartItem.quantity < currentItem.quantity) {
              tmpItem = this.clone(currentItem);
              tmpItem.quantity = cartItem.quantity - currentItem.quantity;
              removeItems.push(tmpItem);
            }

            break;
          }
        }

        if (!found) {
          removeItems.push(cartItem);
        }
      }
    }

    if (addItems.length > 0) {
      value = 0;
      for (i = 0; i < addItems.length; i++) {
        if (addItems[i].hasOwnProperty("price")) {
          qty = addItems[i].hasOwnProperty("quantity") ? addItems[i].quantity : 1;
          value += addItems[i].price * qty;
        }
      }

      this.dlPush({
        'event': this.evtPrefix + 'addToCart',
        'ecommerce': {
          'currencyCode': this.ecData.currency,
          'add': {
            'products': addItems.map(item => this.getGaEcommItem(item))
          }
        }
      });

      this.sendGa2Event("add_to_cart", {
        value: value / 100,
        currency: this.ecData.currency,
        items: addItems.map(item => this.getGa2EcommItem(item))
      });
    }

    if (removeItems.length > 0) {
      value = 0;
      for (i = 0; i < removeItems.length; i++) {
        if (removeItems[i].hasOwnProperty("price")) {
          qty = removeItems[i].hasOwnProperty("quantity") ? removeItems[i].quantity : 1;
          value += removeItems[i].price * qty;
        }
      }

      this.dlPush({
        'event': this.evtPrefix + 'removeFromCart',
        'ecommerce': {
          'currencyCode': this.ecData.currency,
          'remove': {
            'products': removeItems.map(item => this.getGaEcommItem(item))
          }
        }
      });

      this.sendGa2Event("remove_from_cart", {
        value: value / 100,
        currency: this.ecData.currency,
        items: removeItems.map(item => this.getGa2EcommItem(item))
      });
    }

    this.cart = currentItems;
  };

  this.clone = function(obj) {
    if (null == obj || "object" != typeof obj) return obj;
    let copy = obj.constructor();
    for (let attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
    }
    return copy;
}


  this.getGaTransactionItem = function(product) {
    var ret = {
      name: product.name
    };
    if (product.hasOwnProperty("price")) {
      ret.price = product.price / 100;
    }
    if (product.hasOwnProperty("category")) {
      ret.category = product.category;
    }
    if (product.hasOwnProperty("id")) {
      ret.sku = product.id;
    }
    if (product.hasOwnProperty("quantity")) {
      ret.quantity = product.quantity;
    }

    return ret;
  };


  this.getGaEcommItem = function(product) {
    var ret = {
      name: product.name
    };
    var optionalProperties = ["id", "category", "variant", "quantity", "list", "position", "brand"];
    for (var prop of optionalProperties) {
      if (product.hasOwnProperty(prop)) {
        ret[prop] = product[prop];
      }
    }
    if (product.hasOwnProperty("price")) {
       ret.price = product.price / 100;
    }
    if (product.hasOwnProperty("visitDate")) {
      ret.dimension1 = product.visitDate;
    }
    return ret;
  };


  this.getGa2EcommItem = function(product) {
    var ret = {
      "name": product.name
    };
    var optionalProperties = ["id", "category", "variant", "quantity", "position", "brand"];
    for (var prop of optionalProperties) {
      if (product.hasOwnProperty(prop)) {
        ret[prop] = product[prop];
      }
    }
    if (product.hasOwnProperty("price")) {
      ret.price = product.price / 100;
    }
    if (product.hasOwnProperty("list")) {
      ret.location = { "id": product.list };
      ret.location_id = product.list;
    }
    if (product.hasOwnProperty("visitDate")) {
      ret.start_date = product.visitDate;
      ret.end_date = product.visitDate;
    }
    return ret;
  };

  this.getEcItem = function(data) {
    let optionalProperties = ["id", "category", "variant", "list", "position"];
    let optionalNumbers = ["price", "quantity", "taxRate"];
    let taxRate = data.hasOwnProperty("taxRate") ? parseInt(data.taxRate) : 0;
    let ret = {
      'name': data.name,
      'brand': data.hasOwnProperty("brand") ? data.brand : this.ecData.brand
    };

    for (let prop of optionalProperties) {
      if (data.hasOwnProperty(prop)) {
        ret[prop] = data[prop];
      }
    }

    for (let prop of optionalNumbers) {
      if (data.hasOwnProperty(prop)) {
        ret[prop] = parseInt(data[prop]);
        if (prop == "price" && taxRate > 0) {
          ret.price -= ret.price * taxRate / 10000;
        }
      }
    }

    if (data.hasOwnProperty("ticketDate")) {
      ret.visitDate = data.ticketDate;
    }
    else if (data.hasOwnProperty("date")) {
      ret.visitDate = data.date;
    }
    return ret;
  };


  this.dlPush = function(content) {
    window.dataLayer.push(content);
  };
}
